/**
 * Created by minimus on 26.06.2015.
 */
const zoneRules = options.rules.rules;
const singleRules = options.rules.single;
const item = options.item;
const places = options.places;
const pageSize = options.itemsPerPage;

(function($) {
  const ejLocale = (options.locale.changeLocale) ? options.locale.locale : 'en-US';
  const localeStrings = options.strings;
  $(document).ready(function() {
    let dmRules;
    let dmSRules;
    let rulesGrid;
    let sRulesGrid;
    const rulesDialog = $('#rulesDialog').ejDialog({
      width: 830,
      allowDraggable: true,
      enableModal: true,
      showOnInit: false
    }).data('ejDialog');
    const singleDialog = $('#singleDialog').ejDialog({
      width: 830,
      allowDraggable: true,
      enableModal: true,
      showOnInit: false
    }).data('ejDialog');
    const rulesSel = new Selectors();
    const singleSel = new Selectors();

    rulesSel.sid = ''; singleSel.sid = '';
    rulesGrid = $('#rulesGrid').ejGrid({
      dataSource: zoneRules,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Multiple,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: pageSize
      },
      columns: [
        {field: 'slug', visible: false},
        {field: 'tax', headerText: localeStrings.type},
        {field: 'name', headerText: localeStrings.name},
        {field: 'term_slug', visible: false},
        {field: 'priority', visible: false}
      ],
      rowSelected: function(args) {
        if(!rulesSel.service) {
          rulesSel.page = args.model.pageSettings.currentPage;
          const d = rulesSel.pids[rulesSel.page].slice(0);
          const cr = d.indexOf(args.data.slug);
          if(cr > -1) rulesSel.removePid(args.data.slug);
          else rulesSel.pids = args.data.slug;
        }
      },
      actionComplete: function(args) {
        const d = rulesSel.ids.slice(0);
        rulesSel.service = true;
        if(d.length !== 0) {
          for(let i = 0; i < this.model.currentViewData.length; i++) {
            for(let j = 0; j < d.length; j++) {
              if(d[j] === this.model.currentViewData[i].slug) {
                this.multiSelectCtrlRequest = true;
                this.selectRows(i);
                if(args.requestType === 'paging') {
                  rulesSel.page = args.currentPage;
                  rulesSel.pids = this.model.currentViewData[i].slug;
                }
                else if(args.requestType === 'refresh') {
                  rulesSel.page = 1;
                  rulesSel.pids = this.model.currentViewData[i].slug;
                }
              }
            }
          }
        }
        rulesSel.service = false;
      }
    }).data('ejGrid');

    sRulesGrid = $('#singleGrid').ejGrid({
      dataSource: singleRules,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Multiple,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: pageSize
      },
      columns: [
        {field: 'slug', visible: false},
        {field: 'tax', headerText: localeStrings.type},
        {field: 'name', headerText: localeStrings.name},
        {field: 'term_slug', visible: false},
        {field: 'priority', visible: false}
      ],
      rowSelected: function(args) {
        if(!singleSel.service) {
          singleSel.page = args.model.pageSettings.currentPage;
          const d = singleSel.pids[singleSel.page].slice(0);
          const cr = d.indexOf(args.data.slug);
          if(cr > -1) singleSel.removePid(args.data.slug);
          else singleSel.pids = args.data.slug;
        }
      },
      actionComplete: function(args) {
        const d = singleSel.ids.slice(0);
        singleSel.service = true;
        if(d.length !== 0) {
          for(let i = 0; i < this.model.currentViewData.length; i++) {
            for(let j = 0; j < d.length; j++) {
              if(d[j] === this.model.currentViewData[i].slug) {
                this.multiSelectCtrlRequest = true;
                this.selectRows(i);
                if(args.requestType === 'paging') {
                  singleSel.page = args.currentPage;
                  singleSel.pids = this.model.currentViewData[i].slug;
                }
                else if(args.requestType === 'refresh') {
                  singleSel.page = 1;
                  singleSel.pids = this.model.currentViewData[i].slug;
                }
              }
            }
          }
        }
        singleSel.service = false;
      }
    }).data('ejGrid');

    $('#cancel-rules').on('click', () => (rulesDialog.close()));

    $('#select-rules').on('click', (e) => {
      e.preventDefault();

      const rules = rulesSel.sid;
      const aRules = rules.split(',');
      const data = [];
      aRules.forEach((elem) => {
        const found = zoneRules.find((el) => (el.slug === elem));
        if (found) data.push(found);
      });
      if(data.length > 0) {
        $.post(ajaxurl, {
          action: 'add_zone_rules',
          zid: item,
          rules: data,
          sam_pro_nonce: options.samProNonce
        }).done(() => {
          generalGrid.refreshContent();
        });
      }

      rulesDialog.close();
    });

    $('#cancel-single').on('click', () => (singleDialog.close()));

    $('#select-single').on('click', (e) => {
      e.preventDefault();

      const rules = singleSel.sid;
      const aRules = rules.split(',');
      const data = [];
      aRules.forEach((elem) => {
        const found = singleRules.find((el) => (el.slug === elem));
        if (found) data.push(found);
      });
      if(data.length > 0) {
        $.post(ajaxurl, {
          action: 'add_zone_single_rules',
          zid: item,
          rules: data,
          sam_pro_nonce: options.samProNonce
        }).done(() => (singleGrid.refreshContent()));
      }

      singleDialog.close();
    });

    const dmGeneral = ej.DataManager({
      url: ajaxurl + '?action=load_zone_rules&item=' + item + '&sam_pro_nonce=' + options.samProNonce,
      updateUrl: ajaxurl + '?action=update_zone_rule&item=' + item + '&sam_pro_nonce=' + options.samProNonce,
      removeUrl: ajaxurl + '?action=remove_zone_rule&item=' + item + '&sam_pro_nonce=' + options.samProNonce,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmSingle = ej.DataManager({
      url: ajaxurl + '?action=load_zone_single_rules&item=' + item + '&sam_pro_nonce=' + options.samProNonce,
      updateUrl: ajaxurl + '?action=update_zone_single_rule&item=' + item + '&sam_pro_nonce=' + options.samProNonce,
      removeUrl: ajaxurl + '?action=remove_zone_single_rule&item=' + item + '&sam_pro_nonce=' + options.samProNonce,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });

    const generalGrid = $('#aGrid').ejGrid({
      dataSource: dmGeneral,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Single,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: pageSize
      },
      editSettings: {allowEditing: true, allowDeleting: true, showDeleteConfirmDialog: true},
      toolbarSettings: {
        showToolbar: true,
        toolbarItems: [
          ej.Grid.ToolBarItems.Edit,
          ej.Grid.ToolBarItems.Update,
          ej.Grid.ToolBarItems.Cancel,
          ej.Grid.ToolBarItems.Delete
        ],
        customToolbarItems: [
          'Refresh',
          'Add'
        ]
      },
      toolbarClick: function (args) {
        const tBarObj = $(args.target);
        if (tBarObj.hasClass("Refresh")) {
          this.refreshContent();
        }
        else if (tBarObj.hasClass('Add')) {
          rulesDialog.open();
        }
      },
      create: function (args) {
        $('.Refresh').parent('li').attr('title', localeStrings.refresh);
        $('.Add').parent('li').attr('title', localeStrings.add);
      },
      actionComplete: function (args) {
        const $tb = $('#aGrid_toolbarItems');
        let li;
        li = $('#aGrid_delete');
        $tb.ejToolbar('disableItem', li);
      },
      recordClick: function (args) {
        const $tb = $('#aGrid_toolbarItems');
        let li;
        const recs = this.getSelectedRecords();
        const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
        li = $('#aGrid_delete');
        $tb.ejToolbar(action, li);
      },
      columns: [
        {field: 'zid', allowEditing: false, visible: false},
        {field: 'slug', headerText: localeStrings.slug, isPrimaryKey: true, allowEditing: false, visible: false},
        {field: 'single', allowEditing: false, visible: false},
        {
          field: 'priority',
          headerText: localeStrings.priority,
          allowEditing: false,
          visible: false,
          width: 100
        },
        {field: 'tax', headerText: localeStrings.type, allowEditing: false/*, width: 220*/},
        {field: 'name', headerText: localeStrings.name, allowEditing: false},
        {field: 'term_slug', allowEditing: false, visible: false},
        {
          field: 'pid',
          foreignKeyField: 'pid',
          foreignKeyValue: 'title',
          dataSource: places,
          headerText: localeStrings.place,
          visible: true
        }
      ]
    }).data('ejGrid');

    const singleGrid = $('#sGrid').ejGrid({
      dataSource: dmSingle,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Single,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: pageSize
      },
      editSettings: {allowEditing: true, allowDeleting: true, showDeleteConfirmDialog: true},
      toolbarSettings: {
        showToolbar: true,
        toolbarItems: [
          ej.Grid.ToolBarItems.Edit,
          ej.Grid.ToolBarItems.Update,
          ej.Grid.ToolBarItems.Cancel,
          ej.Grid.ToolBarItems.Delete
        ],
        customToolbarItems: [
          'Refresh',
          'Add'
        ]
      },
      toolbarClick: function (args) {
        const tBarObj = $(args.target);
        if (tBarObj.hasClass("Refresh")) {
          this.refreshContent();
        }
        else if (tBarObj.hasClass('Add')) {
          singleDialog.open();
        }
      },
      create: function (args) {
        $('.Refresh').parent('li').attr('title', localeStrings.refresh);
        $('.Add').parent('li').attr('title', localeStrings.add);
      },
      actionComplete: function (args) {
        const $tb = $('#sGrid_toolbarItems');
        let li;
        li = $('#sGrid_delete');
        $tb.ejToolbar('disableItem', li);
      },
      recordClick: function (args) {
        const $tb = $('#sGrid_toolbarItems');
        let li;
        const recs = this.getSelectedRecords();
        const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
        li = $('#sGrid_delete');
        $tb.ejToolbar(action, li);
      },
      columns: [
        {field: 'zid', allowEditing: false, visible: false},
        {field: 'slug', headerText: localeStrings.slug, isPrimaryKey: true, allowEditing: false, visible: false},
        {field: 'single', allowEditing: false, visible: false},
        {
          field: 'priority',
          headerText: localeStrings.priority,
          textAlign: ej.TextAlign.Right,
          editType: ej.Grid.EditingType.Numeric,
          width: 100
        },
        {field: 'tax', headerText: localeStrings.type, allowEditing: false},
        {field: 'name', headerText: localeStrings.name, allowEditing: false},
        {field: 'term_slug', allowEditing: false, visible: false},
        {
          field: 'pid',
          foreignKeyField: 'pid',
          foreignKeyValue: 'title',
          dataSource: places,
          headerText: localeStrings.place,
          visible: true
        }
      ]
    }).data('ejGrid');
  });
})(jQuery);